import { useState, Children, isValidElement, cloneElement } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { Col } from "../../App.styles";
import { HelpButton, HelpCol, RowInfoContainer } from "./RowInfo.style";

const Child = ({ child, onDismiss, show }) => {
  if (isValidElement(child)) {
    return cloneElement(child, { show, onDismiss });
  }

  return child;
};

const RowInfo = ({ children, help = null, rowClassName = '', colClassName = '', hasLabel = true, isFull = false }) => {
  const [show, setShow] = useState(false);
  // Check if helper is a placeholder and not a real help component
  const isHelpPlaceholder = typeof help?.type === 'string'

  return (
    <RowInfoContainer className={`row-info__container ${rowClassName}`}>
      {
        children && help
          ? (
            <>
              <Col size={isFull ? 12 : 10} className={colClassName}>
                { children }
              </Col>
              <HelpCol $isFull={isFull} size="2" className={`${hasLabel ? 'align-items-start': ''} col--stretch`}>
                {
                  isHelpPlaceholder
                    ? null
                    : (
                      <HelpButton type="button" onClick={() => setShow(true)} tabIndex={-1}>
                        <FontAwesomeIcon icon={faQuestionCircle} />
                      </HelpButton>
                    )
                }
                {
                  Children.map(help, (child) => (
                    <Child 
                      child={child} 
                      show={show} 
                      onDismiss={() => setShow(false)} 
                    />
                  ))
                }
              </HelpCol>
            </>
          )
          : children
      }
    </RowInfoContainer>
  );
};

export default RowInfo;